export default function ContactSection() {
  const contactDetails = [
    {
      label: "Address",
      icon: "ri-map-pin-2-line",
      lines: ["SARAJEVO MIS IRBINA 26"],
    },
    {
      label: "City",
      icon: "ri-building-2-line",
      lines: ["Sarajevo"],
    },
    {
      label: "Zip Code",
      icon: "ri-mail-send-line",
      lines: ["71000"],
    },
    {
      label: "Country",
      icon: "ri-earth-line",
      lines: ["Bosnia and Herzegovina"],
    },
    {
      label: "Email",
      icon: "ri-at-line",
      lines: ["contact@magradoo.com"],
      isEmail: true,
    },
    {
      label: "Phone Number",
      icon: "ri-phone-line",
      lines: ["+1 7624759143"],
    },
  ];

  return (
    <section id="contact" className="w-full bg-[#0F1419] py-24 md:py-36 relative overflow-hidden">
      {/* Decorative watermark */}
      <div className="absolute bottom-0 left-0 right-0 flex items-end justify-center overflow-hidden pointer-events-none select-none">
        <span
          className="font-black text-white/[0.03] leading-none font-['Space_Grotesk'] whitespace-nowrap"
          style={{ fontSize: "clamp(80px, 15vw, 200px)" }}
        >
          MAGRA
        </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <p className="text-emerald-400 text-xs font-semibold tracking-[0.2em] uppercase mb-4">Get in Touch</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight font-['Space_Grotesk']">
            Contact<br />
            <span className="text-white/30">MAGRA d.o.o.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Left: contact info */}
          <div className="flex flex-col gap-5">
            {contactDetails.map((item) => (
              <div
                key={item.label}
                className="flex items-start gap-4 p-5 rounded-xl bg-white/5 border border-white/10"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-400/10 border border-emerald-400/20 shrink-0">
                  <i className={`${item.icon} text-emerald-400 text-base`} />
                </div>
                <div>
                  <p className="text-white/40 text-xs font-semibold tracking-widest uppercase mb-1">{item.label}</p>
                  {item.lines.map((line) => (
                    <p key={line} className="text-white text-base font-medium">
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Right: map + brand */}
          <div className="flex flex-col gap-6">
            {/* Map */}
            <div className="rounded-2xl overflow-hidden border border-white/10 flex-1 min-h-[300px]">
              <iframe
                title="MAGRA d.o.o. Location - Sarajevo"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.123456789!2d18.4131!3d43.8563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4775903e0e0e0e0f%3A0x0!2sMis%20Irbina%2026%2C%20Sarajevo%2071000%2C%20Bosnia%20and%20Herzegovina!5e0!3m2!1sen!2s!4v1700000000000!5m2!1sen!2s"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: "300px" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* Brand card */}
            <div className="rounded-2xl bg-white/5 border border-white/10 p-8 flex flex-col gap-3">
              <p className="text-white font-black text-3xl font-['Space_Grotesk']">MAGRA d.o.o.</p>
              <p className="text-white/50 text-sm leading-relaxed">
                A team of experts developing modern applications for the iOS platform. Our products are designed to enhance user experience and improve the security of mobile devices.
              </p>
              <div className="flex items-center gap-3 mt-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10">
                  <i className="ri-apple-line text-white text-sm" />
                </div>
                <span className="text-white/40 text-xs tracking-widest uppercase">iOS Development Studio</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-sm">
            &copy; {new Date().getFullYear()} MAGRA d.o.o. All rights reserved.
          </p>
          <p className="text-white/20 text-xs tracking-widest uppercase">
            iOS Development &bull; Security &bull; Performance
          </p>
        </div>
      </div>
    </section>
  );
}
